import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BookOpen, GraduationCap, Video, Certificate, ChalkboardTeacher } from "@phosphor-icons/react";
import { CourseCatalog } from "./CourseCatalog";
import { MyLearning } from "./MyLearning";
import { CourseBuilder } from "./CourseBuilder";

export function LMSDashboard() {
  const [activeTab, setActiveTab] = useState("catalog");

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-900 to-slate-700 dark:from-white dark:to-slate-300">
          Learning & Development
        </h2>
        <p className="text-slate-500 dark:text-slate-400">
          Upskill with courses, track progress, and earn certificates.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3 lg:w-auto">
          <TabsTrigger value="catalog" className="gap-2">
            <BookOpen className="w-4 h-4" />
            <span className="hidden md:inline">Course Catalog</span>
          </TabsTrigger>
          <TabsTrigger value="mylearning" className="gap-2">
            <GraduationCap className="w-4 h-4" />
            <span className="hidden md:inline">My Learning</span>
          </TabsTrigger>
          <TabsTrigger value="instructor" className="gap-2">
            <ChalkboardTeacher className="w-4 h-4" />
            <span className="hidden md:inline">Instructor Mode</span>
          </TabsTrigger>
        </TabsList>

        <div className="mt-6">
          <TabsContent value="catalog" className="space-y-4">
            <CourseCatalog />
          </TabsContent>

          <TabsContent value="mylearning" className="space-y-4">
            <MyLearning />
          </TabsContent>

          <TabsContent value="instructor" className="space-y-4">
            <CourseBuilder />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
